export const toCurrency = (amount, currency = 'usd', maximumFractionDigits = 2) => {
    const { format } = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
        maximumFractionDigits
    })

    return format(amount);
}